import {VIEWTYPE} from "../components/util/utilData"
import {GlobalState} from "./interface/globalInterface"
import {Action} from "./interface/baseInterface"
import {isProduction} from "../function/base/checkProduct"
const invokeFunc = (key: string, value: any) => {
    isProduction ? null : console.log(key, value)
}
const defaultModel = {
    invokeAsync: invokeFunc,
}
const globalState = {
    model: defaultModel,
    viewType: VIEWTYPE.CREATE,
    serverUrl: "",
    billid: "",
}

export const globalReducer = (state: GlobalState = globalState, action: Action) => {
    const payload = action.payload
    switch (action.type) {
        case "TDAInit": {
            return {
                ...globalState,
            }
        }
        case "setServerUrlAndViewTypeAndBillId":
            return {
                ...state,
                serverUrl: payload.url,
                viewType: payload.viewType,
                billid: payload.billid,
            }
        case "setModel":
            return {
                ...state,
                model: payload,
            }
        case "setServerUrl":
            return {
                ...state,
                serverUrl: payload,
            }
        case "setViewType":
            return {
                ...state,
                viewType: payload,
            }
        case "outputMsg":
            state.model.invokeAsync("resultData", {
                code: "0",
                message: payload,
            })
            return {
                ...state,
            }
        default:
            return {...state}
    }
}
